import { getAccountsQueryOptions } from '@features/accounts/api';
import { filterAccountsByType } from '@features/accounts/filterAccountsByType';
import CheckingSettingsLayout from '@src/routes/_authenticated/dashboard/checking/$accountId/-checking-settings-layout';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/dashboard/checking/$accountId/settings',
)({
  loader: async ({ context }) => {
    const accounts = await context.queryClient.ensureQueryData({
      queryKey: getAccountsQueryOptions.queryKey,
      queryFn: getAccountsQueryOptions.queryFn,
    });

    const { checkingAccount } = filterAccountsByType(accounts?.visible);

    if (!checkingAccount) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    return { checkingAccount };
  },
  component: CheckingSettingsLayout,
});
